import ChevronLeft from '@material-ui/icons/ChevronLeft';
import React from 'react';
import { Img } from '~frontend-common/components/ui';
import { useTranslator } from '~frontend-common/i18n/translator';
import { Box, BoxProps } from '~ui-kit/components/box/box';
import { Button } from '~ui-kit/components/button/button';
import { Typography } from '~ui-kit/components/typography/typography';
import { theme } from '~ui-kit/theme';

interface PageHeaderProps extends Pick<BoxProps, 'mt' | 'mb' | 'my'> {
  title: string;
  subtitle: string | React.ReactNode;
  icon?: string;
  backButtonOnClick?: () => void;
}

export function PageHeader({ title, subtitle, icon, backButtonOnClick, ...rest }: PageHeaderProps) {
  const { tl } = useTranslator();

  return (
    <Box flexDirection="column" {...rest}>
      {backButtonOnClick && (
        <Box mb={4}>
          <Button onClick={backButtonOnClick} size="sm" appearance="outlined" color="secondary">
            <ChevronLeft />
            {tl('ui.navigation.back')}
          </Button>
        </Box>
      )}

      <Box alignItems="center">
        {icon && <Img src={icon} width="48px" height="48px" mr={2} />}

        <Typography component="h1" $fontFamily="Montserrat" $fontSize="32px" $fontWeight={500}>
          {title}
        </Typography>
      </Box>

      <Typography component="p" $fontSize="16px" $mt={2} $color={theme.colors.grayDarkish}>
        {subtitle}
      </Typography>
    </Box>
  );
}
